import { Steps } from './interfaces'

export const shoppingCartSteps: Steps[] = [
  {
    title: 'Validare produse',
    description: ''
  },
  {
    title: 'Selecteaza client',
    description: ''
  },
  {
    title: 'Detalii plata si livrare',
    description: ''
  },
  {
    title: 'Plasare comanda',
    description: ''
  },
  {
    title: 'Verificare bon',
    description: ''
  },
  {
    title: 'Finalizare factura',
    description: ''
  }
]
